export default { sha: '1257f044299cecf6429501d2d634b1aca674def0', buildNumber: 'undefined' }
